import _ from 'lodash';
import moment from 'moment';
import {
  UPLOAD_API,
  CLIP_UPLOAD_API,
  imageVerificationƒ
} from "@/utils/common";

export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: (time) => {
          return time.getTime() > Number(moment(this.ruleForm.be_time
            .end_date).format('x'))
        }
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          return time.getTime() < Number(moment(this.ruleForm.be_time
            .begin_date).format('x'))
        }
      },

      loading: false,
      formLoading: false,
      params: {},
      baseAPI: UPLOAD_API,
      imageConfig: this.$store.state.common.config,
      clipUploadAPI: CLIP_UPLOAD_API,

    }

  },
  computed: {
    show: {
      // getter
      get() {
        return this.value;
      },
      // setter
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    getFormFun() {
      if (this.type == "edit") {
        this.$nextTick(() => {
          let form = _.cloneDeep(this.form);
          for (let key in this.ruleForm) {
            form[key] != undefined ? (this.ruleForm[key] = form[key]) : "";
          }
        });
      }
    },
    saveForm(redirection=false) {

      this.$refs.ruleForm.validate(valid => {
        if (!this.saveFormCallBack()) return;
        if (valid) {
          this.validCallBack();
          this.loading = true;
          if (this.type == 'edit') {
            this.updateFormApi({ ...this.params }).then(res => {
              if (res.status == '1') {

                if(redirection == true) {
                    this.goToPrevRouter(); //全页面
                }else {
                    this.dialogFormVisible(true);  //模态框页面
                }
                setTimeout(() => {
                  this.$message.success('更新成功');

                }, 300);
              } else {
                this.$message.error(res.info);
              }
              this.loading = false;
            }).catch(res => {
              this.loading = false;
            })
          } else {
            this.saveFormApi({ ...this.params }).then(res => {
              if (res.status == '1') {
                if(redirection == true) {
                    this.goToPrevRouter(); //全页面
                }else {
                    this.dialogFormVisible(true);  //模态框页面
                }
                setTimeout(() => {
                  this.$message.success('保存成功');

                }, 300);

              } else {
                this.$message.error(res.info);
              }

              this.loading = false;
            }).catch(res => {
              this.loading = false;
            })

          }
        } else {
          if (!this.show) { // 判断如果在弹窗状态为false时触发的表单验证，则清除验证
            this.$refs['ruleForm'].clearValidate();
          }
        }
      })
    },
    // 返回上一层路由
    goToPrevRouter(routerName = '') {
        if(routerName == '') {
            this.$router.go(-1); 
        }else {
            this.$router.push({
                name: routerName
            });
        }
    },
    validCallBack() {

    },

    clearForm() {
      this.clearFormCallBack(); // 清楚表单前回调
      this.$refs['ruleForm'].resetFields();
      // this.$refs['ruleForm'].clearValidate();

    },

    /**
     * 关闭弹窗并清除表单数据
     */
    dialogFormVisible(load) {
      this.clearForm();
      if (this.$refs.contentedit) {
        console.log('进来执行了')
        this.$refs.contentedit.clearEdit();
      }
      if (load) {
        this.$emit('changeModalState', false, true);
      } else {
        this.$emit('changeModalState', false);
      }

    },

    removeSingleUpload(file, fileList, key) {
      this.ruleForm[key] = fileList;
      if (key) {
        this.uploadFormVerification(key);
      }
      this.removeCallBack();
    },

    successSingleUpload(res, file, fileList, key) {
      console.log('successSingleUpload')
      if (res.status == '1') {

        // 改成支持传的key是“arr[1]”的模式

        // let jsCode = `this.ruleForm.${key} = val`

        // let setVal = new Function('val',jsCode)
        // setVal([res.data.upload_url])
        this.ruleForm[key] = [res.data.upload_url];
        this.singleUploadCallBack(res);
      }
      this.uploadFormVerification(key);
      this.successCallBack();
    },



    imageUploadBefore(file, ident) {
      // 产品
      const config = this.$store.state.common.config[ident];
      return imageVerification(
        this,
        file,
        config
      );
    },
    // 判断上传状态改变是否触发表单验证
    uploadFormVerification(key) {
      let childrenEle = this.$refs.ruleForm.$children;
      console.log('childrenEle', childrenEle, key)
      let has_verification = childrenEle.some(item => {
        if (item.prop == key || item['customProp'] == key) {
          return true
        } else {
          return false
        }
      })
      if (has_verification) {
        this.$refs.ruleForm.validateField(key);
      }
    },

    saveFormCallBack() {
      let cloneForm = _.cloneDeep(this.ruleForm);
      this.params = {
        ...cloneForm,
        id: this.id
      };
      return true;
    },

    singleUploadCallBack(res) {

    },

    removeCallBack() {
      // 图片移除成功回调函数
    },

    successCallBack() {
      // 图片上传成功回调函数
    },

    clearFormCallBack() {

    },

    // 过滤已经存在的app,arr1-原有产品列表，arr2已经存在的app value值数组
    filterApp(arr1, arr2) {
      return arr1.filter((ele) =>
        arr2.filter((x) => parseInt(x) == parseInt(ele.value)).length <= 0
      );
    },
    cropperRemove(val, key) {
      this.ruleForm[key] = [];
    },

    cropperSuccess(res, data, key) {
      console.log("TCL: cropperSuccess -> res, data, key", res, data, key)
      this.ruleForm[key] = [{ name: '', url: res.data.url }];
      this.$refs.ruleForm.validateField(key);
    },

  }
};
